// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","visuallyHidden":"Hero_visuallyHidden__Kn7XQ"};